function blogFind(datHref) {
  fetch(datHref)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");
      let targetElement = document.querySelector(".main-blog");
      let sourceElement = html.querySelector(".main-blog");
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });
}
function blogpagination(event, datHref) {
  let nextPage = event.target.getAttribute("data-currentpage");
  let maxPage = event.target.getAttribute("data-totalpage");
  let dataurl = `${datHref}?page=${nextPage}`;

  fetch(dataurl)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");
      let targetElement = document.querySelector(".blog-articles");
      let sourceElement = html.querySelectorAll(".blog-articles__article");
      for (html of sourceElement) {
        if (targetElement && sourceElement) {
          targetElement.appendChild(html);
        }
      }
      event.target.setAttribute("data-currentpage", Number(nextPage) + 1);
    })
    .finally(() => {
      if (nextPage == maxPage) {
        event.target.remove();
      }
    });
}




// --------------------------search-bar-js---------------------------




document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('BlogSearchInput');
  const articlesContainer = document.getElementById('BlogArticlesContainer');
  const loadMoreBtn = document.querySelector('.block_blog-loadmore-button');

  const originalContent = articlesContainer.innerHTML;
  let debounceTimer;

  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      const query = searchInput.value.trim();

      if (!query) {
        articlesContainer.innerHTML = originalContent;
        if (loadMoreBtn) loadMoreBtn.style.display = 'flex';
        return;
      }

      fetch(`/search?type=article&q=${encodeURIComponent(query)}&section_id=blog-search-results`)
        .then(res => res.text())
      .then(html => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const section = doc.querySelector('#shopify-section-blog-search-results');

  if (section) {
    articlesContainer.innerHTML = section.innerHTML;
  } else {
    articlesContainer.innerHTML = '<p style="text-align:center;">No results found</p>';
  }

  if (loadMoreBtn) loadMoreBtn.style.display = 'none';
});

    }, 400);
  });
});